import React, { useState } from "react";
import GradientButton from "../../../../components/button/Button";
import VendorDetailsModal from "./VendorDetailsModal";
import axiosInstance from "../../../../axiosInstance";

interface Owner {
  id: string;
  full_name: string;
  email: string;
  phone_number: string;
  is_verified_email: boolean;
  membership_type: string;
  role: string;
  avatar: string;
  stripe_customer_id: string;
}

interface Product {
  id: string;
  name: string;
  stock_count: number;
  amount: number;
  unit: string;
  description: string;
  image: string;
  tags: string;
}

interface Vendor {
  id: string;
  name: string;
  tagline: string;
  store_code: string;
  description: string;
  email: string;
  phone: string;
  tax_id: string;
  logo: string | null;
  is_verified: boolean;
  stripe_account_id: string | null;
  payment_status: string;
  can_receive_payments: boolean;
  owner: Owner;
  addresses: any[];
  products: Product[];
}

interface VendorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (filters: { contact: string }) => void;
  onVendorAdded?: (vendor: any) => void;
}

const AddVendorModal: React.FC<VendorModalProps & { vendors: any[] }> = ({
  isOpen,
  onClose,
  onFilter,
  vendors = [],
}) => {
  const [contact, setContact] = useState("");
  const [detailsModal, setDetailsModal] = useState(false);
  const [vendorData, setVendorData] = useState<Vendor | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFilter = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.get(
        `/ventures/search?store_code=${contact}`
      );
      if (res.data && res.data.data) {
        console.log(res.data.data);

        setVendorData(res.data.data); // data is the venture object
        setDetailsModal(true);
      } else {
        setError("Vendor not found.");
      }
    } catch (err) {
      setError("Vendor not found or network error.");
    }
    setLoading(false);
    onFilter({ contact });
  };

  if (!isOpen) return null;

  return (
    <div className="orders-modal">
      <div className="orders-modal__overlay" onClick={onClose}></div>
      <div className="orders-modal__content">
        <div className="orders__modal__header" style={{ marginBottom: 30 }}>
          <h2 className="orders-modal__title">Add Vendor</h2>
          <button className="orders-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form
          className="orders-modal__form"
          onSubmit={(e) => {
            e.preventDefault();
            handleFilter();
          }}
        >
          <div className="orders-modal__form-group full">
            <label htmlFor="contact">Vendor ID</label>
            <input
              type="text"
              id="contact"
              name="contact"
              placeholder="Vendor ID"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          {error && (
            <div style={{ color: "red", marginBottom: 10 }}>{error}</div>
          )}
        </form>
        {contact && (
          <div className="orders-modal__actions">
            <div className="orders-modal__apply">
              <GradientButton
                onClick={handleFilter}
                text={loading ? "Loading..." : "Send"}
                disabled={loading}
              />
            </div>
          </div>
        )}
      </div>

      <VendorDetailsModal
        isOpen={detailsModal}
        onClose={() => setDetailsModal(false)}
        vendor={vendorData}
        vendors={vendors}
      />
    </div>
  );
};

export default AddVendorModal;
